import React from "react";
import { useSelector } from "react-redux";
import { AutoComplete, Popover } from "antd";
import SearchModal from "./SearchModal";
import "../../styles/searchBar.scss";
import Avatar from "antd/lib/avatar/avatar";

const title = {
  posts: "Search Topics",
  blogs: "Search Blogs",
  authors: "Search Blogs by Authors",
};

const placeholder = {
  posts: "Search by Title or Hashtag",
  blogs: "Search by Blog Name",
  authors: "Search by Author Name",
};

const selDropOptions = [
  { id: "posts", display: "Posts" },
  { id: "blogs", display: "Blogs" },
  { id: "authors", display: "Authors" },
];

const tempSelDropOptions = {
  posts: "Posts",
  blogs: "Blogs",
  authors: "Authors",
};

const SearchBar = ({
  selDrop,
  setSelDrop,
  searchValue,
  onSearchChange,
  onSuggestionClick,
  onSearchClick,
  onClear,
  suggestions,
}) => {
  // const { suggestions } = useSelector(({ search }) => ({
  //   suggestions: search.suggestions,
  // }));
  const [popoverVisible, setPopoverVisible] = React.useState(false);

  return (
    <div className="subheader ">
      <div className="container-fluid max-w-screen-xl m-auto text-center">
        <h1 className="text-white mb-4 font-bold">{title[selDrop]}</h1>
        <div className="search-container">
          <Popover
            open={popoverVisible}
            className="search-popover"
            trigger="click"
            placement="bottom"
            onOpenChange={(visible) => setPopoverVisible(visible)}
            content={
              <SearchModal
                options={selDropOptions}
                setOption={setSelDrop}
                className="select-drop"
                setPopoverVisible={setPopoverVisible}
              />
            }
          >
            <div className="dropdown cursor-pointer">
              <span className="text">{tempSelDropOptions[selDrop]}</span>
              <span className="down">▼</span>
            </div>
          </Popover>

          <div className="search-box relative">
            <span className="icon" />
            <AutoComplete
              className="auto-complete"
              bordered={false}
              allowClear={true}
              value={searchValue}
              onSearch={onSearchChange}
              onSelect={onSuggestionClick}
              placeholder={placeholder[selDrop]}
              onClear={onClear}
              onKeyUp={({ key }) => {
                if (key === "Enter") {
                  onSearchClick();
                }
              }}
            >
              {suggestions.map((s, idx) => {
                let initials = "";
                let split = s.title.split(" ");
                initials = `${split[0].charAt(0)}${
                  split.length > 1 ? split[1].charAt(0) : ""
                }`;
                return (
                  <AutoComplete.Option key={idx} value={s.title}>
                    <div className="flex" style={{ alignItems: "center" }}>
                      <Avatar
                        size={34}
                        className="mr-3"
                        icon={initials.toUpperCase()}
                        src={s.imgUrl}
                      />
                      <p style={{ fontSize: "18px" }}>{s.title}</p>
                    </div>
                  </AutoComplete.Option>
                );
              })}
            </AutoComplete>
          </div>
          <button
            className="search-btn mob-hide"
            type="button"
            onClick={onSearchClick}
          >
            SEARCH
          </button>
        </div>
        <button
          className="search-btn w-100 mt-3 ml-0 mob-show"
          type="button"
          onClick={onSearchClick}
        >
          SEARCH
        </button>
      </div>
    </div>
  );
};

export default SearchBar;
